<script setup lang="ts">
import { sortBy } from "lodash-es";
import { computed } from "vue";

import type { AuthUser } from "@/model/user";
import { useSearchMenuStore } from "@/store/search/searchMenu";
import { useUserStore } from "@/store/user";

import AssigneeItemTooltip from "../tooltips/AssigneeItemTooltip.vue";
import SearchDropdown from "./SearchDropdown.vue";
import SelectUser from "./internal/SelectUser.vue";

const store = useSearchMenuStore();
const currentUser = useUserStore().currentUser;

const selection = computed({
  get: () => store.selectedAssignees,
  set: (values: Array<{ id: string }>) => {
    store.selectedAssigneeIds = new Set(values.map((val) => val.id));
  },
});

/**
 * Returns all users currently assigned to any card on this board,
 * with the current user listed first
 */
const currentBoardAssignees = computed(() => {
  const users = store.allAssignees.filter((user) => user.almMapping !== "alm-only");
  const currentUserFirst = (user: AuthUser) => user.id !== currentUser?.id;
  return sortBy(users, [currentUserFirst]);
});
</script>

<template>
  <SearchDropdown
    name="assignee"
    icon="persona/user"
    label-key="general.assignees"
    :selected="selection.length > 0"
  >
    <template #tooltip>
      <AssigneeItemTooltip :assignees="selection" />
    </template>
    <SelectUser
      v-model="selection"
      :values="currentBoardAssignees"
      :header="$t('general.assignees')"
    />
  </SearchDropdown>
</template>
